import { useCompany } from 'hooks/useCompany';
import { ReactNode, createContext } from 'react';

type CompanyContextType = ReturnType<typeof useCompany>;

const defaultContextValue: CompanyContextType = {
  companyId: undefined,
  company: undefined,
  companyAccountId: undefined,
  licensee: undefined,
  changeCompany: Promise.resolve,
  setLatestOrFirstOrDefaultCompany: Promise.resolve,
  setDefaultCompany: Promise.resolve,
  changeCompanyAccount: Promise.resolve,
  refreshCompany: Promise.resolve,
  refreshLicensee: Promise.resolve,
};

export const CompanyContext = createContext<CompanyContextType>(defaultContextValue);

export const CompanyContextProvider = ({ children }: { children: ReactNode }) => {
  const company = useCompany();

  return <CompanyContext.Provider value={company}>{children}</CompanyContext.Provider>;
};
